import React from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from "../../../../../_common/_form/FormInput"
import { Validators } from "../../../../../_common/_form/Validators"


const NRTQuestionMultiple = (props) => {
    return (
        <div>
            <NRTFormInput
                name={props.code}
                type={'radiogroup'}
                validators={[ Validators.required() ]}
                value={props.answer ? props.answer.code : null}
                disabled={props.disabled}
                customProps={{
                    options: props.optionDTOs.sort((a, b) => (a.order - b.order)).map((option)=>({
                        display: option.text,
                        value: option.code
                    }))
                }}
            />
        </div>
    )
}


NRTQuestionMultiple.propTypes = {
    id: PropTypes.string.isRequired  ,
    statements: PropTypes.arrayOf(PropTypes.string)
}

NRTQuestionMultiple.defaultProps = {}


export default NRTQuestionMultiple



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Questions/_components/Multiple/index.js